// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/text-align-justify.js';

import { paths } from '../generated/text-align-justify';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('text-align-justify', Original, paths);
